import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import BeamerScriptLoader from 'components/BeamerScriptLoader';
import ThirdPartyScriptLoader from 'components/Common/ThirdPartyScriptLoader';

import { isOAuthCallbackRoute } from 'helpers/authCallback';
import env from 'helpers/env';
import { generateHubspotVisitorIdentificationId } from 'helpers/hubspotLiveChat';
import { isZoomAppAgent } from 'helpers/zoomApp';

import { bootstrapGoogleTagManager } from '../../scripts/googleTagManagerBootstrap';
import { initializeThirdPartyScripts } from '../../scripts/thirdPartyScripts';

const ThirdPartyScripts = ({ force = false }) => {
  useEffect(() => {
    const canLoadThirdPartyScripts =
      window === window.parent && !isZoomAppAgent();

    if (canLoadThirdPartyScripts && (force || !isOAuthCallbackRoute())) {
      initializeThirdPartyScripts();
      bootstrapGoogleTagManager(import.meta.env.VITE_GTM_CONTAINER_ID);
    }
  }, [force]);

  if (!force && isOAuthCallbackRoute()) {
    return null;
  }

  const notInIframe = window === window.parent;
  const isProductionEnvironment = ['prod', 'staging', 'int'].includes(env.name);

  if (!notInIframe || isZoomAppAgent()) {
    return null;
  }

  return (
    <React.Fragment>
      {isProductionEnvironment && (
        <ThirdPartyScriptLoader
          src={`//js-na1.hs-scripts.com/${env.hubspotTrackingCode}.js`}
          async
          delay={2000}
          id='hs-chat-script-loader'
          onloadCallback={generateHubspotVisitorIdentificationId}
        />
      )}
      <ThirdPartyScriptLoader
        src={`//js.hs-scripts.com/${env.hubspotTrackingCode}.js`}
        async
        delay={10000}
        id='hs-script-loader'
      />
      <ThirdPartyScriptLoader
        src={`https://cdn-cookieyes.com/client_data/${env.cookieYesId}/script.js`}
        async
        delay={5000}
        id='cookieyes'
      />
      <BeamerScriptLoader />
      <ThirdPartyScriptLoader
        src='https://js.chargebee.com/v2/chargebee.js'
        defer
        delay={1000}
        attributes={{
          'data-cb-site': env.chargebeeSiteId
        }}
        id='chargebee-loader'
      />
    </React.Fragment>
  );
};

ThirdPartyScripts.propTypes = {
  force: PropTypes.bool
};

export default ThirdPartyScripts;
